module.exports = __webpack_public_path__ + "static/img/yj_01.0fdaef2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yj_01.jpg
// module id = Maxs
// module chunks = 1